import _ from 'underscore';
import PropTypes from 'prop-types';
import React from 'react';
import { memoize } from '@bingads-webui-universal/primitive-utilities';
import { CampaignOData } from '@bingads-webui-react/campaign-odata';
import { withScope, QueryParam } from '@bingads-webui-react/scope-service';
import { withGlobalFilter } from '@bingads-webui-react/global-filter-context';
import { WaterfallFilterType } from '@bingads-webui/filter-commons';
import { CampaignType, siteMapPropType } from '@bingads-webui-react/with-site-map';
import { filterMapItem, getFilteredCampaignType } from './processor-helpers';

const defaultCampaign = { CampaignType: CampaignType.All };

function smartCampaignFilter(
  campaign,
  globalCampaignType,
  { isSmartPage }
) {
  const isScopedSmartCampaign = campaign && campaign.Id ?
    campaign.CampaignType === 'Smart' :
    false;

  if (isScopedSmartCampaign || globalCampaignType === CampaignType.Smart) {
    // If the global filter is CampaignType.Smart
    // Or if you're scoped to a campaign of type "Smart"
    // Then want to hide all the other tabs
    return isSmartPage;
  }

  return !isSmartPage;
}

const filterMapItemByCampaign = (siteMap, globalCampaignType, currentCampaign) => {
  const campaignFilter = (campaign, item) =>
    smartCampaignFilter(campaign, globalCampaignType, item);

  return filterMapItem(siteMap, _.partial(campaignFilter, currentCampaign));
};

const filterMapItemByCampaignCached = memoize(filterMapItemByCampaign);

/**
 * Only for testing
 */
export const testRef = { current: undefined };

export function processSmartCampaign(Component) {
  const Wrapper = ({ siteMap, ...props }) => {
    const globalCampaignType
      = getFilteredCampaignType(props[WaterfallFilterType.CampaignType]);

    const processor = campaign => (<Component
      {...props}
      siteMap={filterMapItemByCampaignCached(siteMap, globalCampaignType, campaign)}
    />);

    return (
      <CampaignOData
        call={({ currentCampaign }) => currentCampaign.get()}
        escapeHatch={({ currentCampaign }) => (currentCampaign ? undefined : {})}
        fallback={processor(defaultCampaign)}
        onError={() => processor(defaultCampaign)}
        testRef={testRef}
      >
        {campaign => processor(campaign)}
      </CampaignOData>
    );
  };

  Wrapper.propTypes = {
    siteMap: siteMapPropType.isRequired,
    scope: PropTypes.instanceOf(QueryParam).isRequired,
  };

  return withGlobalFilter(withScope(Wrapper));
}

export function processSmartCampaignSearch(Component) {
  const smartCampaignSearchFilter = ({ isSmartPage }) => !isSmartPage;
  const Wrapper = ({ siteMap, ...props }) => (
    <Component {...props} siteMap={filterMapItem(siteMap, smartCampaignSearchFilter)} />
  );

  Wrapper.propTypes = {
    siteMap: siteMapPropType.isRequired,
  };

  return Wrapper;
}
